import { createContext, useContext } from 'react';

export const FormInitialValueContext = createContext<object | undefined>({});

export const useFormInitialValue = () => useContext(FormInitialValueContext);
